import { createTheme } from "@material-ui/core";
import { createTheme as createMuiTheme } from "@mui/material/styles";

const theme = (createTheme as (options?: any) => any)({
  typography: {
    fontFamily: "DM Sans, sans-serif",
  },
  palette: {
    primary: {
      main: "#E1A731",
      light: "#FFF8E1",
      dark: "#D4A353",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#E1A731",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#E53935",
      dark: "#C62828",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#24272C",
      secondary: "#666666",
      disabled: "#888888",
    },
    background: {
      default: "#F5F5F5",
      paper: "#FFFFFF",
    },
    grey: {
      300: "#E8E8E8",
      400: "#9E9E9E",
      500: "#888888",
      600: "#666666",
      700: "#555555",
      800: "#24272C",
    },
    common: {
      white: "#FFFFFF",
      black: "#000000",
    },
    delete: {
      main: "#ED1C24",
      dark: "#D41920",
      contrastText: "#FFFFFF",
      width: "300px",
      height: "48px",
      fontSize: "25px",
      fontWeight: "bold",
      hoverColor: "#cb0000",
    },
    success: {
      main: "#00B621",
      dark: "#009A1B",
      contrastText: "#FFFFFF",
    },
    navbar: {
      background: "#FFFFFF",
      text: "#000000",
      activeBackground: "#FFF4E0",
      activeText: "#E1A731",
      sectionHeader: "#666666",
      iconColor: "#000000",
      activeIconColor: "#E1A731",
      borderColor: "#F0F0F0",
      copyrightText: "#999999",
    },
  },
});
theme.props = {
  MuiButton: {
    delete: {},
  },
  MuiInput: {
    disableUnderline: true,
  },
};

theme.overrides = {
  MuiButton: {
    root: {
      fontWeight: "bold",
      width: "255px",
      fontSize: "33px!important",
      borderRadius: "15px!important",
    },
  },
  MuiInputBase: {
    root: {
      backgroundColor: "#F2F2F6!important",
      borderRadius: "15px!important",
    },
  },
  MuiTextField: {
    root: {
      top: theme.spacing(2),
      backgroundColor: "#F2F2F6!important",
      borderRadius: "15px!important",
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main + "!important",
      },
    },
    "&:hover": {
      backgroundColor: "#E1A731",
      color: "#fff",
    },
    "&focused": {},
  },
  MuiInputLabel: {
    root: {},
    "&focused": {},
  },
  MuiOutlinedInput: {
    root: {
      "&hover": {},
    },
  },
  MuiSwitch: {
    root: {
      top: theme.spacing(3),
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      "&$checked": {
        transform: "translateX(12px)",
        color: theme.palette.common.white,
        "& + $track": {
          opacity: 1,
          backgroundColor: "white",
          borderColor: "13px solid white",
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      backgroundColor: "white",
    },
    track: {
      border: `1px solid black`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "#BDBDBD",
    },
    checked: {},
  },
};

export const goldDatePickerTheme = createMuiTheme({
  palette: {
    primary: {
      main: theme.palette.primary.main,
      contrastText: theme.palette.primary.contrastText,
    },
    secondary: {
      main: theme.palette.primary.main,
    },
  },
});

export default theme;
